<script lang="ts" setup>
import { useNumberFormatter } from '@/composables/useNumberFormatter'

interface Props {
  icon: string
  value: number
  suffix?: string
  iconSize?: number
}

const props = withDefaults(defineProps<Props>(), {
    suffix: '',
    iconSize: 15,
})
</script>

<template>
  <div class="d-flex flex-column align-center gap-x-1">
    <VIcon
      :size="iconSize"
      :icon="icon"
      class="text-secondary"
    />
    <span>
      {{ useNumberFormatter(props.value)
      }}<span v-if="props.suffix">{{ props.suffix }}</span>
    </span>
  </div>
</template>
